import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    this.authenticationService.verifyActiveToken().subscribe({
      next: (res) => {
        this.authenticationService.isUserLoggedin.next(res);
        if (res) {
          return true;
        } else {
          this.router.navigate(['/account/login'], {
            queryParams: { returnUrl: state.url },
          });
          return false;
        }
      },
      error: () => {
        this.authenticationService.isUserLoggedin.next(false);
        this.router.navigate(['/account/login'], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    });
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    this.authenticationService.verifyActiveToken().subscribe({
      next: (res) => {
        this.authenticationService.isUserLoggedin.next(res);
        if (res) {
          return true;
        } else {
          this.router.navigate(['/account/login'], {
            queryParams: { returnUrl: state.url },
          });
          return false;
        }
      },
      error: () => {
        this.authenticationService.isUserLoggedin.next(false);
        this.router.navigate(['/account/login'], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    });
  }
}
